import axios from "axios";
import { handleGetLocal } from "../services/auth-service";

const ACCESS_MAP = {
  None: {
    view: false,
    edit: false,
    add: false,
    full: false,
  },
  View: {
    view: true,
    edit: false,
    add: false,
    full: false,
  },
  Edit: {
    view: true,
    edit: true,
    add: false,
    full: false,
  },
  Add: {
    view: true,
    edit: true,
    add: true,
    full: false,
  },
  Full: {
    view: true,
    edit: true,
    add: true,
    full: true,
  },
};

export const getScreenPermissionFromAccess = (sAccess) => {
  const accessLevel = sAccess || "None";

  return {
    ...(ACCESS_MAP[accessLevel] || ACCESS_MAP.None),
    accessLevel,
  };
};

export const getUserScreenPermission = async (screenName) => {
  const pathname = handleGetLocal("pathURL");
  const gUserId = localStorage.getItem("gUserId");

  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/api/User/get-user-access-forms-by-id-by-formname?gUserId=${gUserId}&sFormName=${screenName}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        Domain: pathname,
      },
    }
  );

  const accessRow = response?.data?.data?.[0];

  return getScreenPermissionFromAccess(accessRow?.sAccess);
};